
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphInstanceGrid extends Serenity.EntityGrid<GraphInstanceRow, any> {
        protected getColumnsKey() { return 'Visualizer.GraphInstance'; }
        protected getDialogType() { return GraphInstanceDialog; }
        protected getIdProperty() { return GraphInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return GraphInstanceRow.localTextPrefix; }
        protected getService() { return GraphInstanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}